module.exports = __webpack_public_path__ + "img/q_4_sor.12b3db5a.png";